export default __webpack_public_path__ + "static/media/gradienta-m_7p45JfXQo-unsplash.a4ed6200.jpg";